import { EventTypes } from './../shared/EventTypes';
import { AutenticationService } from './autentication.service';
import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders,
	HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import { Auth } from './Auth';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { Router } from '@angular/router';
import { AppEventDispatcher } from '../utils/AppEventDispatcher';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AutenticationEventType } from './autentication.event.type';
import { APP_EVENT_DISPATCHER_EVENTS_WHITE_LIST } from './constants/white-list.constants';
import { endpoints, environment } from '../../environments/environment';

@Injectable()
export class AutenticationHttpInterceptor implements HttpInterceptor {

	isRefreshingToken = false;
	tokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	readonly whiteList: string[] = APP_EVENT_DISPATCHER_EVENTS_WHITE_LIST;

	constructor(private inj: Injector, private router: Router) { }

	addToken(req: HttpRequest<any>): HttpRequest<any> {

		var isForgotPassword = req.url.includes(endpoints.accounts.ibPositiveId) || req.url.includes(endpoints.accounts.ibSecurityQuestions);

		if (isForgotPassword && req.method === 'GET') {
			return req;
		}
		if (isForgotPassword && req.method === 'POST') {
			return req.clone({ setHeaders: { 'Identificador': Auth.getInstance().getGUID() } });
		}

		const tokenOAuth = req.headers.get('Authorization') || "";
		if(tokenOAuth === "v2"){
			return req.clone({ setHeaders:
				{
					Authorization: `Bearer ${sessionStorage.getItem('_OmniBearerV2')}`
				}
			});
		}
		if(tokenOAuth.startsWith("Basic")){
			return req.clone();
		}
		return req.clone({ setHeaders:
			{
				'Identificador': Auth.getInstance().getGUID(),
				'Authorization': 'Bearer ' + Auth.getInstance().getOfSession('OmniBearerTokenKey'),
				'Omni-Token': Auth.passToken ? Auth.passToken : '',
				'Codigo-SMS': Auth.codigoSms ? Auth.codigoSms : '',
				'Assinatura-Eletronica': Auth.assinaturaEletronica ? Auth.assinaturaEletronica : '',
				'Codigo-Validacao': Auth.codigoValidacao ? Auth.codigoValidacao : '',
				'Answer-Token': Auth.getSecurityQuestions() ? Auth.getSecurityQuestions() : '',
				'Codigo-Canal': '4'
			}
		});
	}

	urlWhitelisted(url: string): boolean {
		if (this.whiteList.some(v => url.includes(v))) {
			return true;
		}

		return false;
	}


	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		return next.handle(this.addToken(req)).catch((error, caught) => {

			if (error instanceof HttpErrorResponse && !this.urlWhitelisted(req.url)) {
					switch ((<HttpErrorResponse>error).status) {
							case 400:
								return this.handleError(error);
							case 422:
								return this.handle422Error(error);
							case 404:
								return this.handle404Error(error);
							case 401:
								return this.handle401Error(error, req, next);
							case 408:
								return this.handleError(error);
							case 500:
								return this.handle500Error(error);
							case 504:
								return this.handleError(error);
							default:
								return this.haldleDefault(error);
					}

			} else {
				return Observable.throw(error);
			}

		}) as any;
	}

	haldleDefault(error) {
		console.log(error, 'default');
		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		return Observable.throw(error);
	}

	handle422Error(error) {
		console.log(error, 422);
		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		return Observable.throw(error);
	}

	handle404Error(error) {
		console.log(error, 404);
		return Observable.throw(error);
	}

	handle401Error(error, req: HttpRequest<any>, next: HttpHandler) {

		if (error.error.Tipo === 'apiAutenticada') {

			if (!this.isRefreshingToken) {
					this.isRefreshingToken = true;

					// this.tokenSubject.next(null);

					return this.refreshToken()
						.pipe(
						switchMap((newToken: any) => {

							if (newToken.access_token) {
									this.tokenSubject.next(newToken.access_token);
									this.isRefreshingToken = false;
									return next.handle(this.addToken(req));
							}
						}))
						.catch(catchError => {
							AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
							return this.logoutUser();
						});

			} else {
					return this.tokenSubject
						.filter(token => token != null)
						.pipe(switchMap(token => {
								return next.handle(this.addToken(req));
						}));
			}

		} else if (error.error.Tipo === 'SessaoInativa') {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			return this.logoutUser();
		} else if (error.error.Tipo === 'bloqueio') {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			return Observable.throw(error);
		} else {
			return Observable.throw(error);
		}

	}

	handleError(error) {
		if (error && error.status === 400 && error.error && error.error.error === 'invalid_grant') {
			return this.logoutUser();
		} else if (error.error.Tipo !== 'BadRequest') {
			if (error.error.Mensagem.length) {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem});
			} else {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {
					msg: `Houve uma falha na conexão de internet. Por favor tente novamente. ${error.status ? '#' + error.status : ''}`
				});
			}
		} else {
			if (error.error.Mensagem.length) {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem});
			}
		}

		return Observable.throw(error);
	}

	handle500Error(error) {
		console.error(error);
		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: `Houve uma falha na conexão de internet. Por favor tente novamente. ${error.status ?  '#' + error.status : ''}` });
		return Observable.throw(error);
	}

	logoutUser() {
		this.isRefreshingToken = false;
		Auth.getInstance().logout();
		this.router.navigate(['login']);
		AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.LOADER, { show: false });
		return Observable.throw('');
	}

	refreshToken(): Observable<any> {
		const authService = this.inj.get(AutenticationService);
		return authService.auth();
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/autentication.http.interceptor.ts